import { render, staticRenderFns } from "./PropertyRadio.vue?vue&type=template&id=62770805&scoped=true"
import script from "./PropertyRadio.vue?vue&type=script&lang=ts"
export * from "./PropertyRadio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62770805",
  null
  
)

export default component.exports